import { MutationTree } from "vuex";
import { EventCategory } from "./types";
import { getDefaultState } from "./state";

export const mutations: MutationTree<any> = {
	setEventCategoriesTree(state, data: EventCategory[]) {
		state.eventCategoriesTree = data;
	},
	setEventCategoriesList(state, data: EventCategory[]) {
		state.eventCategoriesList = data;
	},
	hideOutcome(_, outcome: EventCategory) {
		outcome.hidden = true;
	},
	showOutcome(_, outcome: EventCategory) {
		outcome.hidden = false;
	},
	hideOutcomeSubTree(_, outcome: EventCategory) {
		outcome.isOpen = false;
	},
	showOutcomeSubTree(_, outcome: EventCategory) {
		outcome.isOpen = true;
	},
	toggleOutcomeSubTree(_, outcome: EventCategory) {
		outcome.isOpen = !outcome.isOpen;
	},
	resetState(state) {
		Object.assign(state, getDefaultState());
	}
}
